import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight, FiGlobe, FiRefreshCw, FiShield } from "react-icons/fi";
import productData from "../Datas/productData";
import { ProductCard } from "./Shop";
import siteConfig, { formatPrice } from "../config/siteConfig";
import "../css/main.scss";

function Main() {
  const featuredProducts = productData.filter((product) => product.tags.includes("new")).slice(0, 8);
  const categoryStories = [
    { label: "Shirts", image: "/main/category-shirts.jpg", to: "/shop?category=Shirts" },
    { label: "Knitwear", image: "/main/category-knitwear.jpg", to: "/shop?category=Knitwear" },
    { label: "Tailoring", image: "/main/category-tailoring.jpg", to: "/shop?tag=tailoring" },
  ];

  return (
    <main className="home-page">
      <section className="home-hero">
        <img src="/main/hero-summer.jpg" alt="A relaxed summer tailoring silhouette" />
        <div className="home-hero__scrim" />
        <div className="home-hero__content">
          <p>ÉDITION 06 — HIGH SUMMER</p>
          <h1>Summer,<br />naturally</h1>
          <Link className="button button--light" to="/shop?tag=summer">
            Discover the edition
          </Link>
        </div>
      </section>

      <nav className="home-category-nav" aria-label="Shop by category">
        {["New in", "Shirts", "Knitwear", "Trousers", "Jackets", "Shoes", "Accessories"].map((label) => (
          <Link
            key={label}
            to={label === "New in" ? "/shop?tag=new" : `/shop?category=${encodeURIComponent(label)}`}
          >
            {label}
          </Link>
        ))}
      </nav>

      <section className="home-products section-pad">
        <div className="section-heading">
          <div>
            <p className="eyebrow">JUST LANDED</p>
            <h2>New arrivals</h2>
          </div>
          <Link className="text-link" to="/shop?tag=new">
            View all <FiArrowRight />
          </Link>
        </div>
        <div className="product-grid">
          {featuredProducts.map((product, index) => (
            <ProductCard product={product} priority={index < 4} key={product.id} />
          ))}
        </div>
      </section>

      <section className="home-editorial-grid section-pad" aria-label="Seasonal edits">
        {categoryStories.map((story, index) => (
          <Link className={`editorial-card editorial-card--${index + 1}`} to={story.to} key={story.label}>
            <img src={story.image} alt="" loading="lazy" />
            <span>{story.label}</span>
            <small>Discover</small>
          </Link>
        ))}
      </section>

      <section className="home-manifesto">
        <p className="eyebrow">THE {siteConfig.wordmark} WARDROBE</p>
        <h2>Less, but better.</h2>
        <p>
          Clothes with a sense of permanence: generous natural fabrics, balanced proportions and details
          that reveal themselves slowly. Designed for calm confidence, wherever life takes you.
        </p>
        <Link className="text-link" to="/about">
          Discover our story <FiArrowRight />
        </Link>
      </section>

      <section className="home-story section-pad">
        <div className="home-story__image">
          <img src="/main/atelier-story.jpg" alt="A tailor shaping a wool jacket in the atelier" loading="lazy" />
        </div>
        <div className="home-story__copy">
          <p className="eyebrow">SAVOIR-FAIRE</p>
          <h2>Made with intention</h2>
          <p>
            We work closely with specialist ateliers and choose materials for their hand, character and
            ability to age beautifully. Every line is considered; every finish earns its place.
          </p>
          <Link className="button button--outline" to="/about#craft">
            Our approach
          </Link>
        </div>
      </section>

      <section className="home-journal section-pad">
        <div className="section-heading section-heading--center">
          <div>
            <p className="eyebrow">THE JOURNAL</p>
            <h2>Postcards from the season</h2>
          </div>
        </div>
        <div className="journal-grid">
          <Link to="/shop?tag=summer">
            <img src="/main/journal-getaway.jpg" alt="Natural canvas espadrilles in the summer light" loading="lazy" />
            <span>THE GETAWAY EDIT</span>
            <h3>Pack lightly</h3>
          </Link>
          <Link to="/about">
            <img src="/main/journal-craft.jpg" alt="Inside a quiet menswear workshop" loading="lazy" />
            <span>BEHIND THE SEAMS</span>
            <h3>The patience of a good jacket</h3>
          </Link>
          <Link to="/shop?category=Shirts">
            <img src="/main/journal-shirt.jpg" alt="A striped shirt in soft daylight" loading="lazy" />
            <span>STYLE NOTES</span>
            <h3>The shirt, reconsidered</h3>
          </Link>
        </div>
      </section>

      <section className="service-strip" aria-label="Shopping services">
        <div>
          <FiGlobe />
          <h3>Worldwide delivery</h3>
          <p>Complimentary from {formatPrice(siteConfig.shipping.freeThreshold)}</p>
        </div>
        <div>
          <FiRefreshCw />
          <h3>Easy returns</h3>
          <p>{siteConfig.shipping.returnsWindow} days to decide</p>
        </div>
        <div>
          <FiShield />
          <h3>Secure payment</h3>
          <p>Encrypted checkout</p>
        </div>
      </section>
    </main>
  );
}

export default Main;
